import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import type { DataSourceListItem, DataSourceStatus } from "./dataSourcesApi.types";

dayjs.extend(relativeTime);

export interface DataSourceRowViewModel {
  id: string;
  connectionId?: string | null;
  name: string;
  type: string;
  instancesLabel: string;
  lastUpdatedRelative: string;
  lastUpdatedAbsolute: string;
  status: DataSourceStatus;
  statusLabel: string;
  logoUrl: string | undefined;
}

const STATUS_LABEL: Record<DataSourceStatus, string> = {
  connected: "Connected",
  disconnected: "Disconnected",
};

const buildInstancesLabel = (count: number): string =>
  count === 1 ? "1 instance" : `${count} instances`;

export const buildDataConnectorDetailPath = (connectionId: string): string =>
  `/data-connectors/${connectionId}`;

export const mapDataSourceToRow = (
  item: DataSourceListItem,
): DataSourceRowViewModel => ({
  id: item.id,
  connectionId: item.connectionId ?? null,
  name: item.name,
  type: item.type,
  instancesLabel: buildInstancesLabel(item.instanceCount),
  lastUpdatedRelative: dayjs(item.lastUpdatedAt).fromNow(),
  lastUpdatedAbsolute: dayjs(item.lastUpdatedAt).format("HH:mm, DD/MM/YYYY"),
  status: item.status,
  statusLabel: STATUS_LABEL[item.status] ?? item.status,
  logoUrl: item.logoUrl,
});

export const mapDataSourcesToRows = (
  items: DataSourceListItem[],
): DataSourceRowViewModel[] => items.map(mapDataSourceToRow);
